import { ProjectSchedules as ProjectSchedulesIcon } from "./../../Components/Icon";
import ProjectSchedules from "./../../Pages/ProjectSchedules";

const navigation = () => ({
  header: "Project Schedules",
  links: [
    {
      text: "Project Schedules",
      icon: ProjectSchedulesIcon,
      route: "projectschedules",
      component: ProjectSchedules,
    },
  ],
});

export default navigation;
